// removed by extract-text-webpack-plugin
module.exports = {"gridHeadlineText":"src-templates-landing-components-gridSection-component-gridHeadlineText----gridHeadlineText-module---gridHeadlineText---2uC9s"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/landing/components/gridSection/component/gridHeadlineText/gridHeadlineText.module.pcss
// module id = 306
// module chunks = 104033720589488